export default __webpack_public_path__ + "static/careers-benefits-block2-icon03.url-350528835ebb98f4d0153e0ea031d30b.svg";